import React, {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'
import LastStep from '../Service_LastStep'
import Steps from '../Service_Steps'
import TitleStep from '../Service_TitleStep'
import Complaint from '../Service_Complaint'
import FirstStep from '../Service_FirstStep'
import Col from "../Col"
import Container from "../Container"
import CardCaption from '../CardCaption'
import Button from '../Button'
import './Service.sass'

export default class Service extends PureComponent {
  static propTypes = {
    passport: PropTypes.shape({
      id: PropTypes.number,
      category_id: PropTypes.number,
      name: PropTypes.string,
      info: PropTypes.shape({
        term: PropTypes.string,
        price: PropTypes.string,
        titleCaption: PropTypes.string,
        titleInfo: PropTypes.string,
        color: PropTypes.string,
        procedure: PropTypes.object,
        lastStepCaption: PropTypes.string,
        lastStepInfo: PropTypes.string,
        organizations: PropTypes.array
      })
    }).isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      selectedOption: 'online'
    }
  }

  handleOptionChange = (changeEvent) => {
    this.setState({
      selectedOption: changeEvent.target.value
    })
  }

  render() {
    const {passport} = this.props
    const {selectedOption} = this.state
    return (
      passport &&
        <div className="service-wrapper">
          <Container>
            <Col xs={6} sm={12} md={24} lg={24}>
              <section className="nameCategory">
                <CardCaption bsSize="large" iconId={passport.category_id}>
                  {passport.name}
                </CardCaption>
                <Link to={`/categories/${passport.category_id}`}>
                  <Button type="button" bsStyle="arrow-left" bsSize="large">
                    Вернуться в категорию
                  </Button>
                </Link>
              </section>
            </Col>
            <Col xs={6} sm={8} md={18} lg={18}>
              <TitleStep
                term={passport.info.term}
                price={passport.info.price}
                titleCaption={passport.info.titleCaption}
                titleInfo={passport.info.titleInfo}
                color={passport.info.color}
              />
            </Col>
            <Col xs={6} sm={4} md={6} lg={6}>
              {passport.info && passport.info.organizations &&
              <div className="organization">
                <p className="organization__caption">Услугу предоставляет:</p>
                <ul className="organization__list">
                  {passport.info.organizations.map((organization) =>
                    <li className="organization__item" key={organization}>{organization}</li>
                  )}
                </ul>
              </div>
              }
            </Col>
            <Col xs={6} sm={8} md={18} lg={18}>
              <div className="service">
                <FirstStep
                  color={passport.info.color}
                  procedure={passport.info.procedure}
                  handleOptionChange={this.handleOptionChange}
                  selectedOption={selectedOption}
                />
                <Steps
                  color={passport.info.color}
                  selectedOption={selectedOption}
                  procedure={passport.info.procedure}
                />
                <LastStep
                  color={passport.info.color}
                  lastStepCaption={passport.info.lastStepCaption}
                  lastStepInfo={passport.info.lastStepInfo}
                />
              </div>
            </Col>
            <Col xs={6} sm={3} md={6} lg={6}>
              {selectedOption === 'online' && Object.keys(passport && passport.data && passport.data.usluga && passport.data.usluga.schema || {}).length ?
                <Link to={`/passports/${passport.id}/usluga_requests/new`}>
                  <Button bsSize="large" bsStyle="arrow-right">Получить услугу</Button>
                </Link>
                : null
              }
            </Col>
            <Col xs={6} sm={12} md={24} lg={24}>
              <Complaint />
            </Col>
          </Container>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/Service/index.jsx